<template>
  <div class="component">
    <h1>{{ scopedStrings.title }}</h1>
    <div class="stage" v-for="stage in stages" :key="stage.id">
      <h2>{{ stage.name }}</h2>
      <table class="stage-line-container" :class="{tightened: tightenedInterface}">
        <tr>
          <th class="stage-column-header" v-for="columnName in stage.content.columns" :key="columnName.id">{{ columnName }}</th>
        </tr>
        <tr class="stage-line" v-for="line in stage.content.lines" :key="line.id">
          <th class="stage-line-title" v-show="line.name != '' || stage.content.lines.length > 1">{{ line.name}}</th>
          <td class="Indicator" v-for="(indicator, index) in line.labels" :key="indicator.id">
            <div class="Indicator-wrapper">
              <div class="label" v-show="line.labels[index] != ''">{{ line.labels[index] }}</div>
              <div class="value" v-if="line.values[index] === undefined">
                {{ "---" }}
              </div>
              <div class="value" v-else>{{ line.values[index] }}</div>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CpuState",
    props: {
      scopedStrings: {
        type: Object,
        required: true
      },
      initialValue: {
        required: true
      }
    },
    data() {
      return {
        stages: this.initialValue,
        tightenedInterface: false,
      }
    },
    methods: {
      setTightenedInterface(tightened) {
        this.tightenedInterface = tightened;
      },
      update (newStages) {
        this.stages = newStages;
      }
    }
  }
</script>

<style scoped>
  .stage-line-container {
    margin-left: 8px;
  }

  .stage-column-header {
    background-color: var(--component-subheader-background);
    color: var(--component-subheader-foreground);
    font-size: 12px;
    letter-spacing: 1px;
    padding: 4px 4px 0 4px;
    text-transform: uppercase;
  }

  .stage-line {
    vertical-align: baseline;
  }

  .stage-line-title {
    background-color: var(--component-subheader-background);
    color: var(--component-subheader-foreground);
    font-size: 12px;
    letter-spacing: 1px;
    padding: 0px 2px 1px 2px;
    text-align: left;
    text-transform: uppercase;
  }

  .Indicator {
    max-width: 450px;
    padding-bottom: 8px;
    padding-top: 0px;
  }

  .Indicator-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .Indicator .label {
    margin-left: 0px;
  }

  .tightened .stage-line-title {
    padding-bottom: 0;
    padding-top: 4px;
  }

  .tightened .Indicator,
  .tightened .label,
  .tightened .value {
    padding-bottom: 0;
    padding-top: 0;
  }
</style>
